export default __webpack_public_path__ + "static/media/google.a94aa74e.png";